export const userIdFromSdrn = (user) => {
    return user.split(":")[3];
};
//# sourceMappingURL=userUtils.js.map